// extracted by mini-css-extract-plugin
module.exports = {"root":"Status_root__2u5gk","approved":"Status_approved__bXJ5c","rejected":"Status_rejected__3oMq5","expired":"Status_expired__3k_GA","label":"Status_label__2nroN"};